import { AbstractControl, ValidatorFn } from '@angular/forms';

export function fileSizeValidator(file, maxSizeMB: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (file) {
      const maxSizeBytes = maxSizeMB * 1024 * 1024;
      if (file.size > maxSizeBytes) {
        // If the file size exceeds the maximum size, return an error object
        return { 'fileSizeExceeded': true };
      }
    }
    // If no file or file size is within limits, return null (no error)
    return null;
  };
}

